import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadHistoryService {

  constructor(private ws: PostmethodService) { }

  getHistory(leadId: string) {
    return this.ws.wsGet(environment.baseUrl + "/lead/leadHistory/?id=" + leadId);
  }
}
